/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Presentational line-item / creative status labels used on lists,
 * workspace widgets, and edit pages.
 */
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

import {AppSharedModule} from '../common/app-shared.module';
import {LineItemSmoothingLabelComponent} from './smoothing-label-component';
import {LineItemDiagnosticLabelComponent} from './diagnostic-label-component';
import {LineItemSourceLabelComponent} from './line-item-source-component';
import {LineItemStatusLabelComponent} from './status-component';
import {LineItemStatusExplanationLabelComponent} from './status-explanation-component';
import {LineItemExecutionLabelComponent} from './execution-component';
import {ValidationInfoComponent} from './validation-info-component';
import {CopyrightStatusComponent} from './copyright-status-component';
import {CreativeStatusLabelComponent} from './creative-status-component';
import {CreativeSetRecentlyRequestedComponent} from './creative-set-recently-requested-component';
import {ObjectivesViewComponent} from './widget/objectives-view.component';
import {BidsViewComponent} from './widget/bids-view.component';

const LINE_ITEM_LABELS = [
  LineItemSmoothingLabelComponent,
  LineItemDiagnosticLabelComponent,
  LineItemSourceLabelComponent,
  LineItemStatusLabelComponent,
  LineItemStatusExplanationLabelComponent,
  LineItemExecutionLabelComponent,
  ValidationInfoComponent,
  CopyrightStatusComponent,
  CreativeStatusLabelComponent,
  CreativeSetRecentlyRequestedComponent,
  ObjectivesViewComponent,
  BidsViewComponent
];

@NgModule({
  imports: [AppSharedModule, TranslateModule],
  declarations: LINE_ITEM_LABELS,
  exports: LINE_ITEM_LABELS
})
export class LineItemLabelsModule {
}
